import { combine, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

import { ISelectedPlanAddOn } from 'containers/AccountBilling/UpgradeBilling/UpgradeBilling';

export interface ICheckoutDetails {
  name: string;
  duration: string;
  rate: number;
  noOfUsers: number;
  totalRate: number;
  addOns: ISelectedPlanAddOn[];
}

const initialCheckoutDetails: ICheckoutDetails = {
  name: '',
  duration: '',
  rate: 0,
  noOfUsers: 0,
  totalRate: 0,
  addOns: [],
};

const checkoutStore = combine({ checkoutDetails: initialCheckoutDetails }, set => ({
  addCheckoutDetails: (newCheckoutDetails: ICheckoutDetails) => set(() => ({ checkoutDetails: newCheckoutDetails })),
  clearCheckoutDetails: () =>
    set(() => ({
      checkoutDetails: initialCheckoutDetails,
    })),
}));

export const useCheckoutStore = create(persist(checkoutStore, { name: 'checkoutDetails' }));
